<div class="wizard__steps__wrapper">
  <ul class="wizard__steps">
    <li
      *ngFor="let step of steps | async; let i = index"
      [ngClass]="{
        active: (currentStep | async)?.stepIndex === step.stepIndex,
        completed: step.isComplete
      }"
      (click)="onStepClick(step)"
      class="completed"
    >
      <span>{{ step.stepTitle | translate }}</span>
    </li>
  </ul>
</div>
